import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const updateCharger: UseCase<ChargerRepository, 'updateCharger'> = repository => {
  return async (chargerUpdate) => {
    await repository.updateCharger(chargerUpdate)
  }
}
